import { Observable } from 'rxjs';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { fromEvent } from 'rxjs';
import { SubSink } from 'subsink';
import { filter, debounceTime, startWith } from 'rxjs/operators';

import { AuthService, AuthUser } from '@monorepo/ui/auth';
import { SharedService } from './../../../shared/services/shared.service';

@Component({
  selector: 'signgaze-header-container',
  templateUrl: './header-container.component.html',
  styleUrls: ['./header-container.component.scss'],
})
export class HeaderContainerComponent implements OnInit {
  readonly subs = new SubSink();

  @ViewChild('nav', { static: false })
  nav: ElementRef;

  mobileQuery: MediaQueryList;
  currentBookedScreens$: Observable<Screen[]>;
  showDefaultMenu = true;
  subSink: SubSink = new SubSink();
  isDashboard = true;
  isloggedInUser: boolean;
  isShowListing = true;
  howItWorksHeader = false;
  innerWidth: any;
  isMobileActive: boolean;
  listingHeader = true;

  constructor(
    public auth: AuthService,
    private sharedService: SharedService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setInnerHeight();
    this.getCurrentBookedScreens();
    this.checkIfItIsDashboard();
    this.getUser();
  }

  public setInnerHeight(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 768) {
      this.isMobileActive = false;
    } else {
      this.isMobileActive = true;
    }
  }

  private checkIfItIsDashboard(): void {
    this.subSink.sink = this.router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationEnd),
        startWith(this.router)
      )
      .subscribe((event) => {
        const url = event.url.split('/');
        const id = url[url.length - 1];
        if (
          event.url.match('/listings')?.index === 0 &&
          this.isMobileActive === true
        ) {
          this.listingHeader = false;
        } else {
          this.listingHeader = true;
        }
        if (event.url.match('/listings')?.index === 0) {
          this.isShowListing = false;
        } else {
          this.isShowListing = true;
        }
        if (
          event.url === '/' ||
          event.url === '/how-it-works' ||
          event.url.match('/listing/')?.index === 0 ||
          event.url === '/blogs' ||
          event.url === '/blogs/detail'
        ) {
          this.handleFixedMenu();
        } else {
          this.handleDefaultHeader();
        }
        if (
          event.url === '/' ||
          event.url === '/location-manager' ||
          event.url === '/screen-manager' ||
          event.url === '/career' ||
          event.url === '/career/detail' ||
          event.url === '/screen-detail' ||
          event.url === '/screen-manager/edit/' + id ||
          event.url === '/how-it-works' ||
          event.url === '/responsible-hosting' ||
          event.url === '/accessibility' ||
          event.url === '/signgaze-stories' ||
          event.url === '/screen-support' ||
          event.url === '/trust' ||
          event.url === '/presence' ||
          event.url === '/help' ||
          event.url === '/offers' ||
          event.url === '/help/detail' ||
          event.url === '/cancellation' ||
          event.url === '/updates' ||
          event.url === '/invite' ||
          event.url === '/about' ||
          event.url === '/contact' ||
          event.url === '/blogs' ||
          event.url === '/terms-condition' ||
          event.url === '/blogs/detail' ||
          event.url.match('/checkout')?.index === 0 ||
          event.url.match('/listings')?.index === 0 ||
          event.url.match('/listing/')?.index === 0 ||
          event.url.match('/admin')?.index === 0
        ) {
          this.isDashboard = true;
        } else {
          this.isDashboard = false;
        }
        if (
          event.url === '/how-it-works' ||
          event.url === '/blogs' ||
          event.url === '/blogs/detail'
        ) {
          this.howItWorksHeader = true;
          this.handleLightFixedMenu();
        } else {
          this.howItWorksHeader = false;
        }
      });
  }

  private getCurrentBookedScreens(): void {
    this.currentBookedScreens$ = this.sharedService.getCurrentBookedScreens();
  }

  public logout(): void {
    this.auth.signOut();
  }

  private handleFixedMenu(): void {
    fromEvent(document, 'scroll')
      .pipe(debounceTime(20))
      .subscribe({
        next: () => {
          if (
            document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 50
          ) {
            this.nav?.nativeElement.classList.add('scrolled');
            this.isloggedInUser = true;
            this.howItWorksHeader = false;
          } else {
            this.nav?.nativeElement.classList.remove('scrolled');
            this.howItWorksHeader = false;
          }
        },
      });
  }

  private handleLightFixedMenu(): void {
    fromEvent(document, 'scroll')
      .pipe(debounceTime(20))
      .subscribe({
        next: () => {
          if (
            document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 50
          ) {
            this.nav?.nativeElement.classList.add('scrolled');
            this.howItWorksHeader = false;
          } else {
            this.nav?.nativeElement.classList.remove('scrolled');
            this.howItWorksHeader = true;
          }
        },
      });
  }

  private handleDefaultHeader(): void {
    fromEvent(document, 'scroll')
      .pipe(debounceTime(20))
      .subscribe({
        next: () => {
          if (
            document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 50
          ) {
            this.howItWorksHeader = false;
          } else {
            this.howItWorksHeader = false;
          }
        },
      });
  }

  public getUser(): void {
    this.subSink.sink = this.auth.user.subscribe({
      next: (user: AuthUser): void => {
        if (user) {
          this.isloggedInUser = true;
        }
      },
    });
  }
}
